import type { IconSvgObject } from './types';

const UserXIcon: IconSvgObject = [
  ["path", { d: "M15.5 21L18.5 18M18.5 18L21.5 15M18.5 18L15.5 15M18.5 18L21.5 21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2.5 19V16.9704C2.5 15.7281 3.05927 14.5099 4.18968 13.9946C5.5685 13.3661 7.22212 13 9 13C10.4418 13 11.8019 13.2407 13 13.667", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["circle", { cx: "9", cy: "6.5", r: "3.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default UserXIcon;
